import { render, staticRenderFns } from "./authPlainForm.vue?vue&type=template&id=2266bc99&scoped=true&v-else=true&"
import script from "./authPlainForm.vue?vue&type=script&lang=ts&"
export * from "./authPlainForm.vue?vue&type=script&lang=ts&"
import style0 from "./authPlainForm.vue?vue&type=style&index=0&id=2266bc99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2266bc99",
  null
  
)

export default component.exports